import { createFileRoute } from '@tanstack/react-router';
import UseQueryParamsTestPage from 'src/features/test-hooks/useQueryParams/page';

export const Route = createFileRoute('/_authenticated/test-hooks/useQueryParams')({
  component: UseQueryParamsTestPage,
});
